import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
  useParams,
} from "react-router-dom";
import ReactGA from "react-ga4";
import { GOOGLETRACKERKEY } from "./utils/constants";
import PageTitle from "./components/PageTitle";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer/Footer";
import Loader from "./components/loader";
import ScrollToTopButton from "./components/ScrollToTopBtn";

// Routes and Pages
import Home from "./routes/Home";
import AboutUs from "./routes/About/AboutUs";
import ProjectsInitiative from "./routes/About/Projects_Initiative";
import Collaborations from "./routes/About/Collaborations";
import ImpactSection from "./routes/About/Impact";
import PolicyObservatory from "./routes/About/PolicyObservatory";
import LIBSENSEEIFL from "./routes/About/CollaborationsEefl";
// import RuforumPage from "./components/workshop/Ruforum";
import OpenPolicyPage from "./routes/WhatWeDo/OpenPolicy";
import CapacityBuildingPage from "./routes/WhatWeDo/CapacityBuilding";
import OpenAccessPage from "./routes/WhatWeDo/OpenAccess";
import RoadmapPage from "./routes/WhatWeDo/OPS/NationalRoadmap";
import SharedRepo from "./routes/Repo/SharedRepo";
import SharedPublishing from "./routes/Repo/SharedPublishing";
import OpenData from "./routes/Repo/OpenData";
import PIDsService from "./routes/Repo/PIDs";
import NewsSection from "./routes/Media/News/News";
import NewsDetail from "./routes/Media/News/NewsDetail";
import EventSection from "./routes/Media/Events/Event";
import EventDetail from "./routes/Media/Events/EventDetail";
import ContactUs from "./routes/ContactUs";
import NetworkOfExperts from "./routes/CallToAction/NetworkOfExperts";
import ECRGhanaPage from "./routes/RDM/ECRGhana";
import ECRNigeriaPage from "./routes/RDM/ECRNigeria";
import WorkshopDetail from "./routes/WhatWeDo/OPS/RegionalWorkshop";
import NotFoundPage from "./routes/NotFound";
import CopphaPage from "./routes/About/COPPHA";
import DiamonAccessPage from "./routes/About/DiamondAccess";
import GhanaSymposium from "./routes/Symposium/Ghana";
import NigeriaSymposium from "./routes/Symposium/Nigeria";
import BotswanaSymposium from "./routes/Symposium/Botswana";
import TunisiaSymposium from "./routes/Symposium/Tunisia";
import SierraLeoneSymposium from "./routes/Symposium/SierraLeone";
import { redirects } from "./utils/redirects";
import ResourcesPage from "./routes/Resources";
import PolicyObservatoryDetails from "./routes/About/PolicyObservatoryDetails";
// import RuforumMainPage from "./components/workshop/Ruforum-Second";
import Ruforum2Page from "./components/workshop/Ruforum-First";
import RuforumThirdPage from "./components/workshop/Ruforum-main";
import RuforumPage from "./components/workshop/Ruforum-stage";
import CourseDetailPage from "./routes/About/CourseDetails";
import OpenPublishingCoursePage from "./routes/About/OpenPublishingCourse";
import DiamonAccessFrenchPage from "./routes/About/DiamondAccessFrench";
import BlogSection from "./routes/Blogs/BlogSection";
import BlogDetails from "./routes/Blogs/BlogDetails";
import ECRPage from "./routes/RDM/Rdm";
import EcrCountriesPage from "./routes/RDM/EcrCountriesPage";
import EcrCallPage from "./routes/RDM/ECRCall";
import OpenAccessWeek2025 from "./routes/About/OpenAccessWeek";

// Initialize Google Analytics
ReactGA.initialize(GOOGLETRACKERKEY);

// Centralized Metadata Configuration
const pageMetadata = {
  home: {
    title: "Home | LIBSENSE",
    description: "Welcome to LIBSENSE, strengthening open science in Africa",
    keywords:
      "Open Science, LIBSENSE, Africa, Policy, Governance, education, research, researcher, infrastructure, open access, open publishing, open repository, library, institutions, NRENs",
  },
  sharedRegional: {
    title: "Regional Shared Repository | LIBSENSE",
    description: "Regional Shared Repository",
    keywords:
      "Open Science, BAOBAB, Regional Shared Repository, Africa, education, research, researcher, open repository, open infrastructure",
  },
  publishService: {
    title: "Publishing Service | LIBSENSE",
    description: "Publishing Platform for organization or institutions",
    keywords:
      "Open Science, open access, PublishNow, Publishing Service, Platform, Africa, Policy, Governance, education, research, researcher, library, academic journal, editor, publisher",
  },
  openData: {
    title: "National Multi-tenanted Repository | LIBSENSE",
    description:
      "National Multi-tenanted Repository  for organization or institutions",
    keywords:
      "Open Science, Weko3, Platform, Africa, Policy, Governance, research, researcher, interoperability",
  },
  pidsServices: {
    title: "Persistent Identifiers | LIBSENSE",
    description: "Persistent Identifiers for organization or institutions",
    keywords:
      "Open Science, Pids, ARKs, ARK, PidsLink, Africa, Policy, Governance, research, researcher, DOI, museum, archive, libraries, history",
  },
  aboutUs: {
    title: "About Us | LIBSENSE",
    description:
      "Welcome to LIBSENSE, strengthening open science policy, governance and infrastructure in Africa.",
    keywords:
      "Open Science, open access, impact, collaboration, projects, initiatives, policy, policy observatory, Africa, Policy, Governance, infrastructure",
  },
  initiatives: {
    title: "Project Initiatives | LIBSENSE",
    description: "Welcome to LIBSENSE, strengthening open science  in Africa",
    keywords:
      "Open Science, impact, collaboration, projects, initiatives, policy observatory, network of experts, COPPHA, open publishing, early career researcher, Africa, Policy, Governance, research, researcher, professional",
  },
  policyObservatory: {
    title: "Policy Observatory | LIBSENSE",
    description: "Welcome to LIBSENSE, strengthening open science  in Africa",
    keywords:
      "Open Science, impact, collaboration, projects, initiatives, policy-observatory, Africa, Policy, Governance, research, researcher, professional",
  },
  collaboration: {
    title: "Collaborations | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science, impact, collaboration, projects, initiatives, Africa, EIFL, Policy, Governance, research, researcher, open publishing",
  },
  eeiflCollab: {
    title: "LIBSENSE-EIFL Collaboration | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science, impact, collaboration, projects, initiatives, open publishing, COPPHA, Africa, Policy, research, researcher",
  },
  ruforumCollab: {
    title: "LIBSENSE-RUFORUM Collaboration | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, agriculture, data repository, research, researcher",
  },
  impacts: {
    title: "Impact | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science, impact, collaboration, projects, initiatives, Africa, Policy, research, researcher",
  },
  openScienceDetails: {
    title: "Open Science Policy & Governance | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science, collaboration, projects, initiatives, policy-observatory, Africa, Policy, Governance, research, researcher",
  },
  openScience: {
    title: "Open Science Policy & Governance | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional",
  },
  roadMap: {
    title: "Open Science Policy & Governance Roadmap | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional",
  },
  openScienceInfrastructure: {
    title: "Open Science Infrastructure | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional",
  },
  openScienceInfrastructureDetails: {
    title: "Open Science Infrastructure | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional",
  },
  capacityBuilding: {
    title: "Capacity Building | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  capacityBuildingDetails: {
    title: "Capacity Building | LIBSENSE",
    description:
      "Welcome to LIBSENSE, fostering open science policy and governance in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  news: {
    title: "News | LIBSENSE",
    description: "News about open science policy in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement, current news, news, latest news, all news",
  },
  newsDetails: {
    title: "News | LIBSENSE",
    description: "News about open science policy in Africa.",
    keywords:
      "Open Science,impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement, current news, news, latest news, all news",
  },
  events: {
    title: "Events | LIBSENSE",
    description: "News about open science policy in Africa.",
    keywords:
      "Open Science,events, current events, all events, events, impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  eventsDetails: {
    title: "Events | LIBSENSE",
    description: "News about open science policy in Africa.",
    keywords:
      "Open Science, events, current events, all events, events, impact, collaboration, projects, initiatives, policy-observatory, Africa, Policy, Governance, research, researcher, professional, capacity building",
  },
  networkOfExperts: {
    title: "Network of Experts | LIBSENSE",
    description: "network of experts in open science policy in Africa.",
    keywords:
      "Open Science, network of experts, experts, impact, collaboration, projects, initiatives, policy-observatory, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  ECR: {
    title: "ECR | LIBSENSE",
    description: "network of experts in open science policy in Africa.",
    keywords:
      "Open Science, ghana, ecr, nigeria, west africa, network of experts, experts, impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  ECRExpansion: {
    title: "ECR Call | LIBSENSE",
    description: "ECR call for participation and expansion",
    keywords:
      "Open Science, ghana, ecr, nigeria, west africa, network of experts, experts, impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  ECRGhana: {
    title: "ECR Ghana | LIBSENSE",
    description: "network of experts in open science policy in Africa.",
    keywords:
      "Open Science, ghana, ecr, nigeria, west africa, network of experts, experts, impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  ECRNigeria: {
    title: "ECR Nigeria | LIBSENSE",
    description: "network of experts in open science policy in Africa.",
    keywords:
      "Open Science, ghana, ecr, Nigeria, West Africa, network of experts, experts, impact, collaboration, projects, initiatives, policy-observatory, Africa, Policy, Governance, research, researcher, professional, capacity building, research ethics",
  },
  ECRBlog: {
    title: "ECR Blog | LIBSENSE",
    description: "Early Career Researcher (ECR) Blog",
    keywords:
      "Open Science, ghana, ecr, nigeria, west africa, blog, articles, network of experts, experts, impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building capacity improvement",
  },
  Ruforum: {
    title: "Ruforum | LIBSENSE",
    description: "ruforum in open science policy in Africa.",
    keywords:
      "Open Science, west africa, ruforum, experts, impact, collaboration, projects, initiatives, policy-observatory, ruforum, Africa, Policy, Governance, research, researcher, professional, capacity building",
  },
  COPPHA: {
    title: "COPPHA | LIBSENSE",
    description:
      "Coalition for Open Access Publishing of Public Health in Africa (COPPHA)",
    keywords:
      "Open Science, public health, impact, collaboration, projects, initiatives, Africa, Governance, research, researcher, open publishing, peer review, AI, capacity building",
  },
  Diamond: {
    title: "Diamond OA Publishing  | LIBSENSE",
    description: "Diamond OA Publishing in Africa Community of Practice",
    keywords:
      "Open Science,Diamond, Open Acess, Open Publishing, West Africa, experts, impact, collaboration, projects, initiatives, Africa, research, researcher, capacity building capacity improvement",
  },
DiamondFrench: {
  title: "Publication en accès ouvert diamant | LIBSENSE",
  description: "Communauté de pratique de l’édition en accès ouvert diamant en Afrique",
  keywords:
    "Science ouverte, diamant, accès ouvert, édition ouverte, Afrique de l’Ouest, experts, impact, collaboration, projets, initiatives, Afrique, recherche, chercheurs, renforcement des capacités, amélioration des capacités",
}
,
  resources: {
    title: "Resources | LIBSENSE",
    description: "Resources about open science policy in Africa.",
    keywords:
      "Open Science, resources, media, webinar, workshop, Africa, Policy, Governance, education, research, researcher",
  },
  contactUs: {
    title: "Contact Us | LIBSENSE",
    description: "More details about open science policy in Africa.",
    keywords:
      "Open Science, Africa, Policy, Governance, research, researcher, professional",
  },
  GhanaSym: {
    title: "Ghana Open Science Symposium | LIBSENSE",
    description: "More details about open science in Ghana.",
    keywords:
      "Open Science, Africa, Policy, Governance, research, researcher, professional",
  },
  NigeriaSym: {
    title: "Nigeria Open Science Symposium | LIBSENSE",
    description: "More details about open science in Nigeria.",
    keywords: "Open Science, Africa, Policy, Governance, research, researcher",
  },
  BotswanaSym: {
    title: "Botswana Open Science Symposium | LIBSENSE",
    description: "More details about open science in Botswana.",
    keywords: "Open Science, Africa, Policy, Governance, research, researcher",
  },
  TunisiaSym: {
    title: "Tunisia Open Science Symposium | LIBSENSE",
    description: "More details about open science in Tunisia.",
    keywords: "Open Science, Africa, Policy, Governance, research, researcher",
  },
  SierraLeoneSym: {
    title: "Sierra Leone Open Science Symposium | LIBSENSE",
    description: "More details about open science in Sierra Leone.",
    keywords: "Open Science, Africa, Policy, Governance, research, researcher",
  },
  openAccessWeek2025: {
    title: "Open Access Week 2025 | LIBSENSE",
    description: "More details about Open Access Week 2025.",
    keywords: "Open Science, Africa, Policy, Governance, research, researcher",
  },
};

// Scroll to Top Component
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const mainContent = document.getElementById("main-content");
    if (mainContent) mainContent.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  useEffect(() => {
    ReactGA.send("pageview");
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="flex h-screen w-full overflow-hidden">
      <Router>
        <div className="flex grow flex-col content-start overflow-hidden bg-background">
          <Navbar />
          <div
            id="main-content"
            className="scrollbar-thumb-rounded scrollbar-track-rounded grow overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-track-transparent scrollbar-thumb-muted"
          >
            <ScrollToTop />
            <ScrollToTopButton />
            <Routes>
              {/* Dynamic Redirects */}
              {redirects.map(({ from, to }, index) => (
                <Route
                  key={index}
                  path={from}
                  element={<Navigate to={to} replace />}
                />
              ))}

              {/* Routes with Metadata */}
              <Route
                path="/home"
                element={
                  <>
                    <PageTitle {...pageMetadata.home} />
                    <Home />
                  </>
                }
              />
              <Route
                path="/home/shared-repositories"
                element={
                  <>
                    <PageTitle {...pageMetadata.sharedRegional} />
                    <SharedRepo />
                  </>
                }
              />
              <Route
                path="/home/publishing-platforms"
                element={
                  <>
                    <PageTitle {...pageMetadata.publishService} />
                    <SharedPublishing />
                  </>
                }
              />
              <Route
                path="/home/open-data"
                element={
                  <>
                    <PageTitle {...pageMetadata.openData} />
                    <OpenData />
                  </>
                }
              />
              <Route
                path="/home/pids-service"
                element={
                  <>
                    <PageTitle {...pageMetadata.pidsServices} />
                    <PIDsService />
                  </>
                }
              />
              <Route
                path="/about-us"
                element={
                  <>
                    <PageTitle {...pageMetadata.aboutUs} />
                    <AboutUs />
                  </>
                }
              />
              <Route
                path="/about-us/project-initiatives"
                element={
                  <>
                    <PageTitle {...pageMetadata.initiatives} />

                    <ProjectsInitiative />
                  </>
                }
              />
              <Route
                path="/about-us/policy-observatory"
                element={
                  <>
                    <PageTitle {...pageMetadata.policyObservatory} />
                    <PolicyObservatory />
                  </>
                }
              />
              <Route
                path="/about-us/policy-observatory/:id"
                element={
                  <>
                    <PageTitle {...pageMetadata.policyObservatory} />

                    <PolicyObservatoryDetails />
                  </>
                }
              />
              <Route
                path="/about-us/collaborations"
                element={
                  <>
                    <PageTitle {...pageMetadata.collaboration} />
                    <Collaborations />
                  </>
                }
              />
              <Route
                path="/about-us/collaborations/eeifl"
                element={
                  <>
                    <PageTitle {...pageMetadata.eeiflCollab} />
                    <LIBSENSEEIFL />
                  </>
                }
              />
              <Route
                path="/about-us/collaborations/ruforum"
                element={
                  <>
                    <PageTitle {...pageMetadata.ruforumCollab} />
                    {/* <RuforumMainPage /> */}
                    <RuforumThirdPage />
                  </>
                }
              />
              <Route
                path="/about-us/impact"
                element={
                  <>
                    <PageTitle {...pageMetadata.impacts} />

                    <ImpactSection />
                  </>
                }
              />
              <Route
                path="/what-we-do/open-science-policy/:policyType"
                element={
                  <>
                    <PageTitle {...pageMetadata.openScienceDetails} />

                    <OpenPolicyPage />
                  </>
                }
              />
              <Route
                path="/what-we-do/open-science-policy"
                element={
                  <>
                    <PageTitle {...pageMetadata.openScience} />

                    <OpenPolicyPage />
                  </>
                }
              />
              <Route
                path="/what-we-do/open-science-policy/roadmaps"
                element={
                  <>
                    <PageTitle {...pageMetadata.roadMap} />

                    <RoadmapPage />
                  </>
                }
              />
              <Route
                path="/what-we-do/open-infrastructure/:policyType"
                element={
                  <>
                    <PageTitle
                      {...pageMetadata.openScienceInfrastructureDetails}
                    />

                    <OpenAccessPage />
                  </>
                }
              />
              <Route
                path="/what-we-do/open-infrastructure"
                element={
                  <>
                    <PageTitle {...pageMetadata.openScienceInfrastructure} />
                    <OpenAccessPage />
                  </>
                }
              />
              <Route
                path="/what-we-do/capacity-building/:policyType"
                element={
                  <>
                    <PageTitle {...pageMetadata.capacityBuildingDetails} />
                    <CapacityBuildingPage />
                  </>
                }
              />
              <Route
                path="/what-we-do/capacity-building"
                element={
                  <>
                    <PageTitle {...pageMetadata.capacityBuilding} />

                    <CapacityBuildingPage />
                  </>
                }
              />

              <Route
                path="/open-access-week-2025"
                element={
                  <>
                    <PageTitle {...pageMetadata.openAccessWeek2025} />

                    <OpenAccessWeek2025 />
                  </>
                }
              />
              
              <Route
                path="/media/news"
                element={
                  <>
                    <PageTitle {...pageMetadata.news} />

                    <NewsSection />
                  </>
                }
              />
              <Route
                path="/news/:id"
                element={
                  <>
                    <PageTitle {...pageMetadata.newsDetails} />

                    <NewsDetail />
                  </>
                }
              />
              <Route
                path="/media/events"
                element={
                  <>
                    <PageTitle {...pageMetadata.events} />

                    <EventSection />
                  </>
                }
              />
              <Route
                path="/event/:id"
                element={
                  <>
                    <PageTitle {...pageMetadata.eventsDetails} />

                    <EventDetail />
                  </>
                }
              />
              <Route
                path="/resources"
                element={
                  <>
                    <PageTitle {...pageMetadata.resources} />
                    <ResourcesPage />
                  </>
                }
              />
              <Route
                path="/contact-us"
                element={
                  <>
                    <PageTitle {...pageMetadata.contactUs} />
                    <ContactUs />
                  </>
                }
              />

              <Route
                path="/network-of-experts"
                element={
                  <>
                    <PageTitle {...pageMetadata.networkOfExperts} />

                    <NetworkOfExperts />
                  </>
                }
              />
              <Route
                path="/ecr"
                element={
                  <>
                    <PageTitle {...pageMetadata.ECR} />
                    <ECRPage />
                  </>
                }
              />

              <Route
                path="/ecr-expansion-call"
                element={
                  <>
                    <PageTitle {...pageMetadata.ECRExpansion} />
                    <EcrCallPage />
                  </>
                }
              />

              <Route
                path="/ecr-ghana"
                element={
                  <>
                    <PageTitle {...pageMetadata.ECRGhana} />
                    <ECRGhanaPage />
                  </>
                }
              />

              <Route
                path="/ecr-nigeria"
                element={
                  <>
                    <PageTitle {...pageMetadata.ECRNigeria} />
                    <ECRNigeriaPage />
                  </>
                }
              />

              <Route
                path="/ecr-blog"
                element={
                  <>
                    <PageTitle {...pageMetadata.ECRBlog} />
                    <BlogSection />
                  </>
                }
              />

              <Route
                path="/ecr-blog/:slug"
                element={
                  <>
                    <PageTitle {...pageMetadata.ECRBlog} />
                    <BlogDetails />
                  </>
                }
              />

              <Route
                path="/ecr-countries"
                element={
                  <>
                    <PageTitle {...pageMetadata.ECRBlog} />
                    <EcrCountriesPage />
                  </>
                }
              />

              <Route path="/open-science/:title" element={<WorkshopDetail />} />
              <Route
                path="/ruforum"
                element={
                  <>
                    <PageTitle {...pageMetadata.Ruforum} />
                    {/* <RuforumMainPage /> */}
                    <RuforumThirdPage />
                  </>
                }
              />

              <Route
                path="/ruforum-one"
                element={
                  <>
                    <PageTitle {...pageMetadata.Ruforum} />
                    <RuforumPage />
                  </>
                }
              />

              <Route
                path="/ruforum-two"
                element={
                  <>
                    <PageTitle {...pageMetadata.Ruforum} />
                    <Ruforum2Page />
                  </>
                }
              />

              <Route
                path="/ruforum-three"
                element={
                  <>
                    <PageTitle {...pageMetadata.Ruforum} />
                    <RuforumThirdPage />
                  </>
                }
              />

              <Route
                path="/coppha"
                element={
                  <>
                    <PageTitle {...pageMetadata.COPPHA} />
                    <CopphaPage />
                  </>
                }
              />

              <Route
                path="/coppha/peer-review-course"
                element={
                  <>
                    <PageTitle {...pageMetadata.COPPHA} />
                    <CourseDetailPage />
                  </>
                }
              />

              <Route
                path="/coppha/open-publishing-course"
                element={
                  <>
                    <PageTitle {...pageMetadata.COPPHA} />
                    <OpenPublishingCoursePage />
                  </>
                }
              />

              <Route
                path="/diamond-open-access-community-of-practice"
                element={
                  <>
                    <PageTitle {...pageMetadata.Diamond} />
                    <DiamonAccessPage />
                  </>
                }
              />


              <Route
                path="/communaute-de-pratique-de-l-acces-ouvert-diamant"
                element={
                  <>
                    <PageTitle {...pageMetadata.DiamondFrench} />
                    <DiamonAccessFrenchPage />
                  </>
                }
              />

              <Route
                path="/ghana-open-science-symposium"
                element={
                  <>
                    <PageTitle {...pageMetadata.GhanaSym} />
                    <GhanaSymposium />
                  </>
                }
              />

              <Route
                path="/nigeria-open-science-symposium"
                element={
                  <>
                    <PageTitle {...pageMetadata.NigeriaSym} />
                    <NigeriaSymposium />
                  </>
                }
              />
              <Route
                path="/botswana-open-science-symposium"
                element={
                  <>
                    <PageTitle {...pageMetadata.BotswanaSym} />
                    <BotswanaSymposium />
                  </>
                }
              />

              <Route
                path="/tunisia-open-science-symposium"
                element={
                  <>
                    <PageTitle {...pageMetadata.TunisiaSym} />
                    <TunisiaSymposium />
                  </>
                }
              />

              <Route
                path="/sierraleone-open-science-symposium"
                element={
                  <>
                    <PageTitle {...pageMetadata.SierraLeoneSym} />
                    <SierraLeoneSymposium />
                  </>
                }
              />

              <Route path="/en/:title" element={<RedirectOldToNew />} />
              <Route
                path="/en/event/:title"
                element={<RedirectOldToEvents />}
              />

              {/* Add other routes dynamically */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Footer />
          </div>
        </div>
      </Router>
    </div>
  );
};

const RedirectOldToNew = () => {
  const { title } = useParams();

  return <Navigate to={`/news/${title}`} replace />;
};

const RedirectOldToEvents = () => {
  const { title } = useParams();

  return <Navigate to={`/event/${title}`} replace />;
};

export default App;
